/* Calm interactions: number-only fade on quantity change, and keep the Shopify Inbox chat bubble clear of the sticky add-to-cart / cart / pop-ups. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (e) {
    var q = e.target.closest('.quantity__button');
    if (!q || reduce) return;
    var inp = q.parentElement.querySelector('.quantity__input');
    if (!inp) return;
    inp.classList.remove('mz-bump'); void inp.offsetWidth; inp.classList.add('mz-bump');
  });

  var LIQ = '.mz .button, .mz .product-form__submit, .mzl-btn, .mzc__btn, .vt-learn-more-btn, .newsletter-form__button, .product-form__input input[type="radio"] + label';
  function ripple(b, x, y) {
    var r = b.getBoundingClientRect(), s = document.createElement('span');
    s.className = 'mz-water';
    s.style.cssText = '--d:' + Math.max(r.width, r.height) * 1.6 + 'px;left:' + (x == null ? r.width / 2 : x - r.left) + 'px;top:' + (y == null ? r.height / 2 : y - r.top) + 'px';
    b.appendChild(s);
    setTimeout(function () { s.remove(); }, 950);
  }
  if (!reduce) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var b = e.target.closest && e.target.closest(LIQ);
      if (b && !(e.relatedTarget && b.contains(e.relatedTarget))) ripple(b);
    }, { passive: true });
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      var b = e.target.closest && e.target.closest(LIQ);
      if (b) ripple(b, e.clientX, e.clientY);
    }, { passive: true });
  }

  var CHAT_CSS = '.activator-nudge{transform:translate(var(--mz-chat-dx,0px),calc(var(--mz-chat-dy,0px) + var(--mz-chat-y,0px)));opacity:var(--mz-chat-o,1);pointer-events:var(--mz-chat-pe,auto);transition:var(--mz-chat-tr,transform .35s cubic-bezier(.2,.8,.2,1),opacity .2s ease-out);touch-action:none;cursor:grab}';
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function draggable(host, sr) {
    var set = function (k, v) { host.style.setProperty(k, v); };
    var pos = { x: 0, y: 0 };
    try { pos = JSON.parse(ss('mzChatPos')) || pos; } catch (e) {}
    set('--mz-chat-dx', pos.x + 'px'); set('--mz-chat-dy', pos.y + 'px');
    var docked = !!ss('mzChatDock');
    function dockStyle() { if (docked) set('--mz-chat-o', '.9'); else host.style.removeProperty('--mz-chat-o'); }
    dockStyle();
    var drag = null, moved = false;
    function floor() { var s = document.querySelector('.mz-sticky-atc.is-visible'); return s ? s.getBoundingClientRect().top - 8 : innerHeight - 16; }
    sr.addEventListener('pointerdown', function (e) {
      var el = e.target.closest && e.target.closest('.activator-nudge');
      if (!el) return;
      drag = { el: el, sx: e.clientX, sy: e.clientY, bx: pos.x, by: pos.y, t: e.timeStamp, id: e.pointerId };
      moved = false;
    });
    sr.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
      if (!moved && Math.abs(dx) + Math.abs(dy) < 8) return;
      if (!moved) { moved = true; set('--mz-chat-tr', 'none'); try { drag.el.setPointerCapture(drag.id); } catch (err) {} }
      pos.x = drag.bx + dx; pos.y = drag.by + dy;
      set('--mz-chat-dx', pos.x + 'px'); set('--mz-chat-dy', pos.y + 'px');
      var over = drag.el.getBoundingClientRect().bottom - floor();
      if (over > 0) { pos.y -= over; set('--mz-chat-dy', pos.y + 'px'); }
    });
    function end(e) {
      if (!drag) return;
      var d = drag; drag = null;
      if (!moved) return;
      host.style.removeProperty('--mz-chat-tr');
      var r = d.el.getBoundingClientRect(), vw = innerWidth, vh = innerHeight;
      var flick = (e.clientX - d.sx) / Math.max(1, e.timeStamp - d.t);
      if (r.left > vw - r.width * 0.55 || (flick > 0.9 && r.left > vw / 2)) {
        pos.x += vw - 18 - r.left; pos.y += Math.min(Math.max(r.top, 90), floor() - r.height) - r.top;
        set('--mz-chat-dx', pos.x + 'px'); set('--mz-chat-dy', pos.y + 'px');
        docked = true; dockStyle(); ss('mzChatDock', '1'); ss('mzChatPos', JSON.stringify(pos));
        return;
      }
      docked = false; dockStyle(); ss('mzChatDock', '');
      var left = r.left + r.width / 2 < vw / 2 ? 12 : vw - r.width - 12;
      var top = Math.min(Math.max(r.top, 90), floor() - r.height);
      pos.x += left - r.left; pos.y += top - r.top;
      set('--mz-chat-dx', pos.x + 'px'); set('--mz-chat-dy', pos.y + 'px');
      ss('mzChatPos', JSON.stringify(pos));
    }
    sr.addEventListener('pointerup', end);
    sr.addEventListener('pointercancel', end);
    sr.addEventListener('click', function (e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; return; }
      var el = e.target.closest && e.target.closest('.activator-nudge');
      if (el && docked) {
        e.stopPropagation(); e.preventDefault();
        var r = el.getBoundingClientRect();
        pos.x += innerWidth - r.width - 12 - r.left;
        set('--mz-chat-dx', pos.x + 'px');
        docked = false; dockStyle(); ss('mzChatDock', ''); ss('mzChatPos', JSON.stringify(pos));
      }
    }, true);
  }
  function patchChat() {
    var host = document.querySelector('shopify-chat');
    var rt = host && host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
    var sr = rt && rt.shadowRoot;
    if (!sr || !sr.querySelector('.activator-nudge')) return false;
    if (sr.querySelector('style[data-mz]')) return true;
    var st = document.createElement('style');
    st.setAttribute('data-mz', '');
    st.textContent = CHAT_CSS;
    sr.appendChild(st);
    draggable(host, sr);
    return true;
  }
  var tries = 0;
  (function wait() { if (patchChat() || ++tries > 40) return; setTimeout(wait, 500); })();
})();
